import React, { useState } from 'react'
import useAuth from '../../hooks/useAuthContext'
import { toast } from 'react-toastify'
import axiosInstance from '../../hooks/axiosInstance'

const SendInvitation = ({close}) => {
    const {userData} = useAuth()

    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        email: ''
    })

  const handleSubmit = (e) => {
    e.preventDefault()

    if(formData.email === "") {
        toast.error("Pls enter an email address")
        return
    }
    setLoading(true)
    axiosInstance.post(`/association/associations/invitation/send/${userData.userInfo.id}`, formData)
            .then(res => {
                toast.success(res.data.message)
                close()
                // localStorage.setItem('resetEmail', resetData.email)
            })
            .catch(err => {
                console.log(err.response.data);
                toast.error(err.response.data.message)
            })
            .finally(() => setLoading(false))
  }

  const handleChange =(e) =>{
    setFormData({...formData, email:e.target.value})
  }

  return (
    <div>
        <div className="text-center">
            <h5 className="text-primary">Invite a Friend</h5>
            <p className="text-muted mb-0">Send invitation to join <b className='text-info'>{userData?.userInfo?.name}</b></p>

            <lord-icon src="https://cdn.lordicon.com/rhvddzym.json" trigger="loop" colors="primary:#0ab39c" className="avatar-xl"
            style={{height: '7.5rem', width: '7.5rem'}}></lord-icon>
        </div>

        <div className="alert border-0 alert-warning text-center mb-2 mx-2" role="alert">
            Enter invitee email and an invitation will be sent!
        </div>
        <div className="p-2">
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="form-label">Email</label>
                    <input 
                        type="email" 
                        className="form-control" 
                        placeholder="Enter Email" 
                        name='email'
                        value={formData.email}
                        onChange={handleChange}
                    />
                </div>

                <div className="text-center mt-4">
                    <button className="btn btn-success w-100" type="submit" disabled={loading}>
                        {loading ? <div className="spinner-border spinner-border-sm text-light"></div> : 'Send Invitation'}
                    </button>
                </div>
            </form>
            {/* <!-- end form --> */}
        </div>
    </div>
  )
}

export default SendInvitation
